export default __webpack_public_path__ + "media/img/primary-desktop-22e8a1ef75cabe3187cafc4295626989.svg";